var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "authWrapper new-login-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row whiteBG-wrap login-white-wrap"
  }, [_c('div', {
    staticClass: "col-lg-7 col-md-7 no-padding"
  }, [_c('div', {
    staticClass: "login-left-wrap"
  }, [_c('router-link', {
    staticClass: "ms-0 ps-0 login-highlight back-btn-pwd",
    attrs: {
      "to": "/forgot-password"
    }
  }, [_vm._v("Back")]), _vm._m(0), _c('h4', {
    staticClass: "login-title mb-2"
  }, [_vm._v("Send OTP")]), _c('div', {
    staticClass: "auth-form pt-3 pb-3"
  }, [_c('div', {
    staticClass: "verify-option mb-3"
  }, [_c('div', [_c('label', {
    staticClass: "custom-radio "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedVerifyIdentity,
      expression: "selectedVerifyIdentity"
    }],
    attrs: {
      "type": "radio",
      "name": "custom-radio"
    },
    domProps: {
      "value": _vm.verifyIdentityInfo.phone,
      "checked": _vm._q(_vm.selectedVerifyIdentity, _vm.verifyIdentityInfo.phone)
    },
    on: {
      "change": function change($event) {
        _vm.selectedVerifyIdentity = _vm.verifyIdentityInfo.phone;
      }
    }
  }), _c('span', {
    staticClass: "radiomark"
  })])]), _c('div', [_vm._v("Mobile (" + _vm._s(_vm.verifyIdentityInfo.phone) + ")")])]), _c('div', {
    staticClass: "verify-option"
  }, [_c('div', [_c('label', {
    staticClass: "custom-radio "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedVerifyIdentity,
      expression: "selectedVerifyIdentity"
    }],
    attrs: {
      "type": "radio",
      "name": "custom-radio"
    },
    domProps: {
      "value": _vm.verifyIdentityInfo.email,
      "checked": _vm._q(_vm.selectedVerifyIdentity, _vm.verifyIdentityInfo.email)
    },
    on: {
      "change": function change($event) {
        _vm.selectedVerifyIdentity = _vm.verifyIdentityInfo.email;
      }
    }
  }), _c('span', {
    staticClass: "radiomark"
  })])]), _c('div', [_vm._v("Email (" + _vm._s(_vm.verifyIdentityInfo.email) + ")")])]), _c('div', [_c('button', {
    staticClass: "submit-btn mt-3 next-btn ml-0 w-100",
    attrs: {
      "disabled": _vm.otpLoader,
      "type": "button"
    },
    on: {
      "click": _vm.sendOTP
    }
  }, [_vm.otpLoader ? _c('b-spinner', {
    staticClass: "mr-3",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Send Verification Code ")], 1)])])], 1)]), _c('div', {
    staticClass: "col-lg-5 col-md-5 no-padding"
  }, [_c('Logincarsoule')], 1)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "rep-icon-login"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/member-login.svg"),
      "alt": "image-fluid"
    }
  })]);
}]

export { render, staticRenderFns }